module.exports = __webpack_public_path__ + "static/media/icon-video-call.9836e0c3.svg";